import { computed } from 'vue';

import { useCurrentClient } from '../composables/useCurrentClient';

import { useCalculationsStore } from '../store/calculations';

export function useCurrentClientCalculations() {
  const calculationStore = useCalculationsStore();

  const { currentClient } = useCurrentClient();

  const currentClientCalculations = computed(() => {
    if (!currentClient.value || !calculationStore.data) {
      return null;
    }

    return calculationStore.data.filter(
      (calculation) =>
        calculation.client_uuid === currentClient.value?.uuid &&
        (calculation as any).parent_id == null
    );
  });

  return { currentClientCalculations };
}
